import { useInView } from "@react-spring/web";
import { useMemo } from "react";

export const useAnimateInView = () => {
  const [ref, inView] = useInView({
    rootMargin: "0px 0px -100px 0px",
  });

  const animateClassNames = useMemo(() => {
    return inView ? "animate" : "";
  }, [inView]);

  return { ref, animateClassNames };
};
